import request from '@/utils/request';
import type {PaginatedResponse, Status} from '@/types/common';
import type {CreateRoleData, Role, RoleQueryParams, UpdateRoleData} from '@/types/role';
import type {Permission} from '@/types/permission';

export const roleService = {
  // 获取角色列表
  getRoles: async (params: RoleQueryParams): Promise<PaginatedResponse<Role>> => {
    const response = await request.get<PaginatedResponse<Role>>('/api/admin/roles', { params });
    return response;
  },

  // 获取所有角色（不分页）
  getAllRoles: async (): Promise<Role[]> => {
    const response = await request.get<Role[]>('/api/admin/roles/all');
    return response;
  },

  // 获取角色详情
  getRoleById: async (id: number): Promise<Role> => {
    const response = await request.get<Role>(`/api/admin/roles/${id}`);
    return response;
  },

  // 创建角色
  createRole: async (data: CreateRoleData): Promise<Role> => {
    const response = await request.post<Role>('/api/admin/roles', data);
    return response;
  },

  // 更新角色
  updateRole: async (id: number, data: UpdateRoleData): Promise<Role> => {
    const response = await request.put<Role>(`/api/admin/roles/${id}`, data);
    return response;
  },

  // 删除角色
  deleteRole: async (id: number): Promise<void> => {
    await request.delete(`/api/admin/roles/${id}`);
  },

  // 更新角色状态
  updateRoleStatus: async (id: number, status: Status): Promise<void> => {
    await request.patch(`/api/admin/roles/${id}/status`, { status });
  },

  // 分配权限
  assignPermissions: async (id: number, permissionIds: number[]): Promise<void> => {
    await request.post(`/api/admin/roles/${id}/permissions`, { permissionIds });
  },

  // 当前用户可分配的权限
  getAssignablePermissions: async (): Promise<Permission[]> => {
    const response = await request.get<Permission[]>('/api/admin/roles/assignable-permissions');
    return response;
  },
};
